const audit = {
  moduleTitle: "Audit Log",
  actions: {
    view: "View",
  },
  permissions: {
    core: "Core",
    auditManagement: "Audit Management",
    auditLog: "Audit Log",
  },
};

export default audit;
